module.exports = __webpack_public_path__ + "img/contact-us-banner.05fb0b4d.jpg";